/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTaskProgressesQuery } from '../../models/get-task-progresses-query';
import { GetTaskProgressQueryResult } from '../../models/get-task-progress-query-result';

export interface ApiTaskProgressGetTaskProgressesPost$Params {
      body?: GetTaskProgressesQuery
}

export function apiTaskProgressGetTaskProgressesPost(http: HttpClient, rootUrl: string, params?: ApiTaskProgressGetTaskProgressesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTaskProgressQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskProgressGetTaskProgressesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTaskProgressQueryResult>;
    })
  );
}

apiTaskProgressGetTaskProgressesPost.PATH = '/api/TaskProgress/GetTaskProgresses';
